import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "@/views/dashboard/Dashboard.vue";
import leads from "@/views/leads/leads.vue";
import options from "@/views/options/options.vue";
import membership from "@/views/memberships/membership.vue";
import pqr from "@/views/pqrs/pqr.vue";
import pqrDetail from "@/views/pqrs/pqrDetail.vue";
import Profile from "@/views/Profile.vue";
import Rtl from "@/views/Rtl.vue";
import SignIn from "@/views/auth/SignIn.vue";
import SignUp from "@/views/auth/SignUp.vue";
import authMiddleware from "../middleware/authMiddleware";
import ROUTES from "../constansRoute";
import Importaciones from "../views/dashboard/importaciones.vue";
import credencialesPortales from "@/views/credenciales-portales/credencialesPortales.vue";
import externalCredentials from "@/views/external-credentials/externalCredentials.vue";
import plans from "@/views/plans/plans.vue";
import planForm from "@/views/plans/planForm.vue";
import lonjas from "@/views/lonjas/lonjas.vue";
import lonjaDetail from "@/views/lonjas/lonjaDetail.vue";
import aiUsage from "@/views/ai-usage/aiUsage.vue";
import reputacionInmuebles from "@/views/reputacion-inmuebles/reputacionInmuebles.vue";
import eliminacionMasivaInmuebles from "@/views/inmuebles/eliminacionMasiva.vue";
import localidades from "@/views/localidades/localidades.vue";
import roles from "@/views/roles/roles.vue";
import auditoriaPlataforma from "@/views/plataforma/auditoria.vue";
import rolesPlataforma from "@/views/plataforma/rolesPlataforma.vue";
import negociosPlataforma from "@/views/negocios-plataforma/negociosPlataforma.vue";
const routes = [
    {
        path: "/",
        name: "/",
        redirect: "/memberships",
        meta: { requiresAuth: true }, // Agrega una meta propiedad para indicar que la ruta requiere autenticación

    },
    {
        path: "/importaciones/reportes",
        name: ROUTES.IMPORTACIONESREPORTE,
        component: Dashboard,
        meta: { requiresAuth: true }, // Agrega una meta propiedad para indicar que la ruta requiere autenticación

    },
      {
        path: "/importaciones",
        name: ROUTES.IMPORTACIONES,
        component: Importaciones,
        meta: { requiresAuth: true }, // Agrega una meta propiedad para indicar que la ruta requiere autenticación

    },
    {
        path: "/memberships",
        name: ROUTES.MEMBERSHIPS,
        component: membership,
        meta: { requiresAuth: true }, // Agrega una meta propiedad para indicar que la ruta requiere autenticación

    },
    {
        path: "/leads",
        name: ROUTES.LEADS,
        component: leads,
        meta: { requiresAuth: true }, // Agrega una meta propiedad para indicar que la ruta requiere autenticación

    },

    {
        path: "/pqrs",
        name: ROUTES.PQR,
        component: pqr,
        meta: { requiresAuth: true },
    },
    {
        path: "/pqrs/:id",
        name: ROUTES.PQR_DETAIL,
        component: pqrDetail,
        meta: { requiresAuth: true },
    },
    {
        path: "/credenciales-portales",
        name: ROUTES.CREDENCIALES_PORTALES,
        component: credencialesPortales,
        meta: { requiresAuth: true },
    },
    {
        path: "/credenciales-externas",
        name: ROUTES.EXTERNAL_CREDENTIALS,
        component: externalCredentials,
        meta: { requiresAuth: true },
    },

    {
        path: "/planes",
        name: ROUTES.PLANS,
        component: plans,
        meta: { requiresAuth: true },
    },
    {
        path: "/planes/crear",
        name: ROUTES.PLANS_CREATE,
        component: planForm,
        meta: { requiresAuth: true },
    },
    {
        path: "/planes/:id/editar",
        name: ROUTES.PLANS_EDIT,
        component: planForm,
        meta: { requiresAuth: true },
    },
    {
        path: "/lonjas",
        name: ROUTES.LONJAS,
        component: lonjas,
        meta: { requiresAuth: true },
    },
    {
        path: "/lonjas/:id",
        name: ROUTES.LONJAS_DETAIL,
        component: lonjaDetail,
        meta: { requiresAuth: true },
    },
    {
        path: "/consumo-ia",
        name: ROUTES.AI_USAGE,
        component: aiUsage,
        meta: { requiresAuth: true },
    },
    {
        path: "/reputacion-inmuebles",
        name: ROUTES.REPUTACION_INMUEBLES,
        component: reputacionInmuebles,
        meta: { requiresAuth: true },
    },
    {
        path: "/inmuebles/eliminacion-masiva",
        name: ROUTES.PROPERTIES_BULK_DELETE,
        component: eliminacionMasivaInmuebles,
        meta: { requiresAuth: true },
    },
    {
        path: "/localidades",
        name: ROUTES.LOCALIDADES,
        component: localidades,
        meta: { requiresAuth: true },
    },
    {
        path: "/roles",
        name: ROUTES.ROLES,
        component: roles,
        meta: { requiresAuth: true },
    },
    {
        path: "/plataforma/auditoria",
        name: ROUTES.PLATAFORMA_AUDITORIA,
        component: auditoriaPlataforma,
        meta: { requiresAuth: true },
    },
    {
        path: "/plataforma/roles",
        name: ROUTES.PLATAFORMA_ROLES,
        component: rolesPlataforma,
        meta: { requiresAuth: true },
    },
    {
        path: "/plataforma/transacciones",
        name: ROUTES.PLATAFORMA_NEGOCIOS,
        component: negociosPlataforma,
        meta: { requiresAuth: true },
    },
    {
        path: "/opciones",
        name: "options",
        component: options,
        meta: { requiresAuth: true }, // Agrega una meta propiedad para indicar que la ruta requiere autenticación

    },
    {
        path: "/profile",
        name: "Profile",
        component: Profile,
        meta: { requiresAuth: true }, // Agrega una meta propiedad para indicar que la ruta requiere autenticación

    },
    {
        path: "/rtl-page",
        name: "Rtl",
        component: Rtl,
        meta: { requiresAuth: true }, // Agrega una meta propiedad para indicar que la ruta requiere autenticación

    },
    {
        path: "/sign-in",
        name: ROUTES.SIGNIN,
        component: SignIn,
    },
    {
        path: "/sign-up",
        name: ROUTES.SIGNUP,
        component: SignUp,
    },
];



const router = createRouter({
    history: createWebHistory(),
    routes,
    linkActiveClass: "active",
});

router.beforeEach(authMiddleware);
export default router;
